import { useQuery } from "react-query";
import API from "@Config/axios";
import { QUERY_KEY } from "@Constants/query-keys";
import queryString from "query-string";

const fetchPhoneVerificationsSearch = async ({ phone_number, date }) => {
  if (!phone_number || !date) return { data: [] };
  
  const pathname = queryString.stringifyUrl({
    url: "/phone-verifications/search",
    query: {
      phone_number,
      date,
    },
  });
  
  // Note: API base URL already includes '/admin' for admin users based on axios config
  const { data } = await API.get(pathname);
  return data;
};

const useGetPhoneVerificationsSearch = ({ phone_number, date, options = {} }) => {
  return useQuery(
    [QUERY_KEY.GET_PHONE_VERIFICATIONS_SEARCH, { phone_number, date }],
    () => fetchPhoneVerificationsSearch({ phone_number, date }),
    {
      enabled: false, // Wait for user action to trigger search by default
      keepPreviousData: false,
      ...options,
    }
  );
};

export default useGetPhoneVerificationsSearch;
